<div class="header">
  <h1
    class="languages-header-text"
    [ngClass]="{
      'changed-label':
        changes.entityAttributes.includes(jobseekerEnum.Language) && isEdited
    }"
  >
    {{ 'label.Languages' | translate }}
  </h1>
</div>
<div class="languages-container">
  <div
    class="languages"
    *ngFor="let language of languages"
    [ngClass]="{
      'changed-label':
        checkAddedAndModifiedLanguages(language.worldLanguageId) && isEdited
    }"
  >
    <div class="name">
      <span>{{ language.name + ' ' }}</span>
    </div>
    <div class="proficienty">
      <span>{{ language.languageProficiencyLevel }}</span>
    </div>

    <div class="language-files" *ngIf="language?.filename">
      <a [href]="language.filename" class="attachment" target="_blank">
        <svg-icon src="assets/img/attachment.svg"></svg-icon>
        <span style="font-weight: 500; color: #819dcd"
          >{{ 'label.Attachment' | translate }}
        </span>
      </a>
      <app-reject-dialog
        *ngIf="
          checkAddedAndModifiedLanguages(language.worldLanguageId) && isEdited
        "
        [id]="language.objectId"
        (setDictionary)="reject($event)"
      ></app-reject-dialog>
    </div>
  </div>
  <div
    class="deleted-languages"
    *ngIf="
      isEdited &&
      changes.jobseekerLanguageChanges?.removedLanguages?.length &&
      changes.jobseekerLanguageChanges?.removedLanguages?.length > 0
    "
  >
    <div
      class="languages deleted-label"
      *ngFor="let language of changes.jobseekerLanguageChanges.removedLanguages"
    >
      <div class="name">
        <span>{{ language.worldLanguage.name + ' ' }}</span>
      </div>
      <div class="proficienty">
        <span>{{ language.languageProficiencyLevel.name }}</span>
      </div>

      <div class="language-files" *ngIf="language?.attachment?.filename">
        <a
          [href]="language.attachment.filename"
          class="attachment"
          target="_blank"
        >
          <svg-icon src="assets/img/attachment.svg"></svg-icon>
          <span style="font-weight: 500; color: #819dcd"
            >{{ 'label.Attachment' | translate }}
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
